<template>        
  <div class="submissions-filter">
    
    <div class="submissions-filter__fields">

      <div class="submissions-filter__field">
        <label>filter by topics:</label>
        <div class="submissions-filter__tags">

          <span 
            v-for="tag in submissionTags"
            class="submissions-filter__button"          
          >
            <input type="checkbox" :id="tag.id" :value="tag.id" v-model="selectedSubmissionsTags">
            <label 
              :for="tag.id"
              class="submissions-filter__button-label"
              :class="{ 'active': tagIsSelected(tag.id) }"
            >
              {{tag.label}}
              <span class="button__icon">
                <svg v-if="tagIsSelected(tag.id)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16px" height="16px">
                  <path fill="#003F2E" d="M 19.980469 5.9902344 A 1.0001 1.0001 0 0 0 19.292969 6.2929688 L 9 16.585938 L 5.7070312 13.292969 A 1.0001 1.0001 0 1 0 4.2929688 14.707031 L 8.2929688 18.707031 A 1.0001 1.0001 0 0 0 9.7070312 18.707031 L 20.707031 7.7070312 A 1.0001 1.0001 0 0 0 19.980469 5.9902344 z"/>
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                  <path d="M8.00008 3.52686V14.1935M13.3334 8.86019L2.66675 8.86019" stroke="white" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </span>
            </label>
          </span>

        </div>
        
      
        <button 
          class="submissions-filter__clear button button--plain button--small button--white-outline" 
          @click="resetFilter">
          clear
        </button>
      </div>

      <div class="submissions-filter__field">
        <label>
          <span class="submissions-filter__field-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path d="M3.00042 13.38L11.7762 17.7838C11.9173 17.8546 12.0836 17.8546 12.2247 17.7838L21.0004 13.38M3.00042 18.344L11.7762 22.7477C11.9173 22.8185 12.0836 22.8185 12.2247 22.7477L21.0004 18.344M11.7762 2.97279L2.89098 7.43143C2.52332 7.61592 2.52332 8.14071 2.89098 8.32521L11.7762 12.7838C11.9173 12.8547 12.0836 12.8547 12.2247 12.7838L21.1099 8.32521C21.4775 8.14071 21.4775 7.61592 21.1099 7.43143L12.2247 2.97279C12.0836 2.90197 11.9173 2.90197 11.7762 2.97279Z" stroke="white" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </span>
          sort by
        </label>
        <v-select
            :value="selectedSubmissionsSort"
            @input="updateSelectedSubmissionsSort"
            :options="sortingOptions"
            :searchable="false"
            :clearable="false"
            id="sort"
            ref="submissionSortSelector"
            class="submissions-filter__select"
        >
        </v-select>
      </div> 
    </div> 
    

  </div>  
</template>
  
  <script>
  import { mapGetters } from "vuex";
  import { mapFields } from "vuex-map-fields";
  import vSelect from "vue-select";
  
  export default {
    name: "SubmissionsFilter",
    components: {
    //   NewsCard,
        vSelect,
    },
    data() {
      return {
        sortingOptions: [
          { label: "newest first", value: "date-desc" },
          { label: "oldest first", value: "date-asc" },
        ],
      };
    },
    mounted() {
      this.currentPageFromParams();
    },
    computed: {
      ...mapFields([
        "viewContent.submissions",
        "viewContent.submissionTags",
        "submissions.selectedSubmissionsSort",
        "submissions.selectedSubmissionsTags",
      ]),
    },
    watch: {
      selectedSubmissionsTags: {
        handler(id) {
          if (id.length > 0) {
            this.updateURLParams("tag", id);
            this.updateURLParams("page", 1);

            // update store state for submissions.currentPage to 1
            this.$store.commit("resetSubmissionsPagination");
          }
        }
      },
    },
    methods: {
      tagIsSelected(tagId) {
        return this.selectedSubmissionsTags.includes(tagId);
      },
      updateSelectedSubmissionsSort(value) {
        if (value == null) {
          value = {};
        }
  
        this.selectedSubmissionsSort = value;
        this.updateURLParams("sort", value.value);
      },
      currentPageFromParams() {
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has("tag")) {
          // get the type from url
          let paramTag = urlParams.get("tag");
          this.selectedSubmissionsTags = urlParams.get('tag').split(',').map(Number);
        }
      },
      updateURLParams(type, value) {
        const urlParams = new URLSearchParams(window.location.search);
  
        if (value == null) {
          urlParams.delete(type);
        } else {
          urlParams.set(type, value);
        }

        // if (value != null) {
    
          // update the url
          window.history.replaceState(
            {},
            document.title,
            `${window.location.pathname}?${urlParams.toString()}`
          );
        // }

      },
      resetFilter() {
        // clear/reset v-selects
        this.$refs.submissionSortSelector.clearSelection();
        // reset store
        this.$store.commit("resetSubmissionsFiltering");
        this.updateURLParams('tag', null);
        this.updateURLParams('sort', null);
      },
    },
  };
  </script>
  